import React, {useEffect, useRef} from "react";
import PropTypes from 'prop-types';

import {AppsStep} from "./AppsStep/AppsStep";

UpdateAppStep.propTypes = {
  data: PropTypes.array,
  index: PropTypes.number
}

export function UpdateAppStep(props) {
  const stepRef = useRef(null);
  const { nested = false } = props;
  const selectedApp = props?.data?.find(item => item.name === AppsStep.name);

  // On mount, focus the step and scroll into view.
  useEffect(() => {
    if (nested) return;
    stepRef.current.focus({ preventScroll: true });
    window.scrollTo({
      top: (stepRef.current.offsetTop - 120),
      behavior: "smooth"
    });
  }, [])

  return (
    <div ref={stepRef} tabIndex={0}
         className="support-form-step support-form-update-app-step">
      <div className="support-form-step-header">
        <div className="support-form-update-app-step__icon-circle">
          <div className="support-form-update-app-step__icon">
            <span className="support-form-update-app-step__glyph glyph-system-apps"></span>
          </div>
        </div>
        <div className="support-form-step-header__side-line"/>
        <h2 className="support-form-step-header__question">The selected app is out of date.</h2>
        <p className="support-form-step-header__description">Updating the app to the latest version may resolve your issue.</p>
      </div>

      <a className="support-form-update-app-step__button" href={`https://homey.app/a/${selectedApp?.appId}`}>
        <span>Go to the Homey App Store</span>
        <span className="mask-arrow-right"/>
      </a>
    </div>
  );
}
